<template>
  <div class="page_cInsureLog">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="身份证" label-width="68px">
              <el-input v-model="listQuery.cardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="操作人">
              <el-select v-model="listQuery.personId" placeholder="" clearable filterable size="small" style="width:180px">
                <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作类型">
              <el-select v-model="listQuery.optionType" placeholder="" clearable filterable size="small" style="width:180px">
                <el-option v-for="(item, index) in logTypeList" :key="index" :label="item.key" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
          <div>
            <el-form-item label="开始时间" size="small" label-width="96px">
              <el-date-picker v-model="listQuery.beginTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:180px"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="small">
              <el-date-picker v-model="listQuery.endTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:180px"></el-date-picker>
            </el-form-item>
            <el-form-item label="操作平台" size="small">
              <el-select v-model="listQuery.source" placeholder="" clearable size="small" style="width:180px">
                <el-option value="pc"></el-option>
                <el-option value="小程序"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>商保</el-breadcrumb-item>
          <el-breadcrumb-item>操作日志</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <!-- <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNewCala">+新增发薪</el-button>
          <el-button type="success" size="small">导出</el-button>
          <el-button type="warning" size="small">导出人员明细</el-button>
          <el-button type="primary" size="small">导出原始导入表明细</el-button>
        </div> -->
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="OptionTypeName" label="操作类型" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Source" label="操作平台" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OptionUserName" label="操作人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DeptName" label="部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OptionTime" label="操作时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.OptionTime ? row.OptionTime.replace('T',' ') : ''}}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="100px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="getDtl(row)">查看详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalcount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="showDtl" width="1000px">
      <el-form :inline="true" class="re_down_form" label-width="88px">
        <el-form-item label="身份证号码">
          <el-input v-model="dtlQuery.CardId" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="small" @click="getDtl('')" style="margin-left: 15px;">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="dtlData" border class="doc_table" style="width:100%">
        <el-table-column prop="InsuranceName" label="险种名称" min-width="120" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="PersonName" label="参保员工姓名" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="CardId" label="身份证号码" min-width="180" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ProjectName" label="项目名称" min-width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeAttribute" label="员工属性" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Service" label="客服" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Department" label="隶属公司" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="JobClasss" label="职业类别" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="JobName" label="岗位" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ErrMsg" label="保司情况" v-if="optionType=='审批通过报减' || optionType=='审批通过报增'" min-width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination v-if="dtlTotalcount>0" @current-change="currentChange2" :current-page.sync="dtlQuery.pageNum" :page-size="Number(dtlQuery.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="dtlTotalcount"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="showDtl = false" size="small">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from "@/utils/permission"; // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          cardId: "",
          personId: "",
          source: '',
          optionType: '',
          beginTime: '',
          endTime: '',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        userList: [], //用户列表
        dtlQuery: {
          id: '',
          CardId: '',
          pageSize: 10,
          pageNum: 1
        },
        dtlData: [],
        dtlTotalcount: 0,
        showDtl: false, //详情弹窗
        logTypeList: [], //操作类型列表
        optionType: '',
      };
    },
    created() {
      this.getUserList();
      this.LogType();
      this.LogList();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.LogList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.LogList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.LogList();
      },
      //获取用户列表
      getUserList() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        };
        xz.getauthUserInfoByorgancode(dataPage).then((res) => {
          if (res && res.totalcount > 0) {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        });
      },
      //获取操作日志列表
      LogList() {
        xz.LogList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalcount = res.totalcount;
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //获取操作类型
      LogType() {
        xz.LogType().then(res => {
          if (res.status == 'ok') {
            this.logTypeList = res.data;
          } else {
            this.logTypeList = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //查看详情
      getDtl(row) {
        if (row) {
          this.optionType = row.OptionTypeName;
          this.dtlQuery = {
            id: row.Id,
            pageSize: 10,
            CardId: '',
            pageNum: 1
          }
        }
        xz.LosListDetail(this.dtlQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data;
            this.dtlTotalcount = res.totalcount;
            this.showDtl = true;
          } else {
            this.dtlTotalcount = 0;
            this.dtlData = [];
            this.$message.error('获取详情出错')
          }
        })
      },
      currentChange2(val) {
        this.dtlQuery.pageNum = Number(val);
        this.getDtl('');
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.dtlQuery.pageNum = 1;
        this.dtlQuery.pageSize = val;
        this.getDtl('');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_cInsureLog .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_cInsureLog .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_cInsureLog .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_cInsureLog .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_cInsureLog .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_cInsureLog .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_cInsureLog .el-table__fixed {
    height: 100% !important;
  }
</style>